//Theme styles

import './carousel-card.scss';

import { throttle } from 'lodash';
import Swiper, { Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/pagination';

export class CarouselCard {

  constructor() {
    this.swiper = {};
    this.swiperEl = '.swiper-articles';
    this.slideOffet = 0;
    window.addEventListener('DOMContentLoaded', () => this.init());

    document.addEventListener('relatedLoaded', () => {
      this.initSwipper();
      this.updateOnResize();
    });
  }

  init = () => {
    this.setSlideOffset();
  };

  initSwipper = () => {
    this.swiper = new Swiper(this.swiperEl, {
      loop: false,
      spaceBetween: 32,
      slidesPerView: 'auto',
      slidesOffsetBefore: this.slideOffet,
      slidesOffsetAfter: 32,
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      modules: [Pagination],
    });
  }

  setSlideOffset = () => {
    const leftRefEl = document.getElementById('swiper-left-ref');
    this.slideOffet = Math.round(leftRefEl.getBoundingClientRect().left);
  };

  updateOnResize = () => {
    window.addEventListener('resize', throttle(() => {
      this.setSlideOffset();
      this.swiper.params.slidesOffsetBefore = this.slideOffet;
    }, 100));
  }
}

const carouselCard = new CarouselCard();
